import { TextField, ThemeProvider, createTheme } from "@mui/material";
import PropTypes from "prop-types";

const MultilineText = ({
  inputProps,
  onChange,
  onInput,
  value,
  type,
  name,
  error,
  helperText,
}) => {
  const theme = createTheme({
    typography: {
      fontFamily: "Lato",
      body1: {
        color: "#60656D",
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <TextField
        type={type}
        fullWidth
        id="outlined-multiline-static"
        multiline
        rows={4}
        name={name}
        value={value}
        onChange={onChange}
        onInput={onInput}
        inputProps={inputProps}
        error={error}
        helperText={helperText}
      />
    </ThemeProvider>
  );
};

MultilineText.propTypes = {
  inputProps: PropTypes.object,
  helperText: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  onInput: PropTypes.func,
  type: PropTypes.string,
  name: PropTypes.string,
  error: PropTypes.bool,
};

export default MultilineText;
